import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface CollapsibleSectionProps {
  title: string;
  children?: React.ReactNode;
  /** Extra content rendered in the header row, right of the title (hidden when collapsed). */
  headerSlot?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  emptyMessage?: string;
}

export function CollapsibleSection({
  title,
  children,
  headerSlot,
  defaultOpen = false,
  className,
  emptyMessage = "No data available",
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={cn("rounded-xl border border-border bg-card shadow-sm", className)}>
      <div className="flex items-center justify-between px-4 py-5">
        <button
          className="flex items-center gap-1.5 text-left"
          onClick={() => setIsOpen((v) => !v)}
        >
          <span className="text-sm font-semibold text-foreground">{title}</span>
          {isOpen ? (
            <ChevronDown className="size-4 text-muted-foreground" />
          ) : (
            <ChevronRight className="size-4 text-muted-foreground" />
          )}
        </button>
        {isOpen && headerSlot && <div className="flex items-center gap-2">{headerSlot}</div>}
      </div>

      {isOpen && (
        <div className="border-t border-border">
          {children ?? <p className="px-4 py-4 text-sm text-muted-foreground">{emptyMessage}</p>}
        </div>
      )}
    </div>
  );
}

